<div class="container-fluid individual-data-monitor">
  <!-- 全画面のモーダル -->
  <full-modal id="individual-dm-modal" :contentId="modalContentId()" :showModal="showModal" />

  <!-- vue3.5以降でないとdeferが使用できないため、移動先の描画完了までteleport自体を描画しない -->
  <wrapped-teleport :destinationId="graphSettingsDestinationId()" :noRenderTeleport="!measureMounted"
    :disabled="!showModal">
    <!-- OBDの通常表示時のみ位置を少し下げる -->
    <div v-if="!showSelect" class="one-liner-btns" :style="isObd && !showModal ? { 'margin-top': '50px' } : '{}'">
      <div class="left-side-btn">
        <b-button :class="showModal ? '' : 'mt-n5 ml-n4'" variant="primary" size="sm" @click="openMemo"
          :disabled="btnDisabled.memo">
          {{ $t('message.button_vehicle_dtc_note_modal') }}
        </b-button>
        <b-button :class="showModal ? 'ml-1' : 'mt-n5 ml-2'" variant="primary" size="sm" :disabled="btnDisabled.export"
          @click="csvExport">
          {{ $t('message.file_export') }}
        </b-button>
      </div>

      <div class="right-side-btn">
        <!-- グラフ設定ボタン -->
        <no-text-svg-button :class="showModal ? BUTTON_TYPE.RIGHT_TOP : `mt-n5 ${BUTTON_TYPE.RIGHT_TOP}`"
          variant="outline-info" :iconKey="ICON_KEY.CONFIG" @click="handleConfigureGraph" :disabled="btnDisabled.graph"
          :title="$t('individual.button_data_monitor_graph_config')" />

        <!-- リセットズームボタン -->
        <no-text-svg-button :class="showModal ? BUTTON_TYPE.RIGHT_TOP : `mt-n5 ${BUTTON_TYPE.RIGHT_TOP}`"
          variant="outline-info" :iconKey="ICON_KEY.RESET_ZOOM" @click="handleResetZoom($event)"
          :disabled="btnDisabled.resetZoom" :title="$t('individual.label_data_monitor_reset_zoom')" />

        <!-- 最大化ボタン -->
        <no-text-svg-button v-if="!showModal" :class="`mt-n5 ${BUTTON_TYPE.RIGHT_TOP}`" variant="outline-info"
          :iconKey="ICON_KEY.MAXIMUM" @click="maximum()"
          :title="$t('individual.label_data_monitor_hint_maximize_action')" />
        <!-- 最小化ボタン -->
        <no-text-svg-button v-else :class="BUTTON_TYPE.RIGHT_TOP" variant="outline-info" :iconKey="ICON_KEY.MINIMUM"
          @click="minimum()" :title="$t('individual.label_data_monitor_hint_minimize_action')" />

      </div>
    </div>
  </wrapped-teleport>

  <data-monitor class="{'dm-area': showSelect}" ref="data_monitor" :showSelect="showSelect" :inExecution="inExecution"
    :inPlaying="inPlaying" :measureId="measureId" :isUseCache="isUseCache" :isSpecial="isSpecial"
    :dataMonitorFunctionSettings="dataMonitorFunctionSettings" :showModal="showModal" :modalContentId="modalContentId()"
    :graphSettingsDestinationId=graphSettingsDestinationId() :isOnlyCsvExport=false
    @toggle-show-select="toggleShowSelect" @toggle-execute="toggleExecute" @toggle-playing="togglePlaying"
    @change-measure-id="changeMeasureId" @back-select="backSelect" @exec-stop-monitor="stopMonitor"
    @change-check-value="changeCheckValue" @current-tab-changed="currentTabChanged"
    @zoom-pan-state-changed="zoomPanStateChanged" @maximum="maximum" @minimum="minimum"
    @measure-mounted="measureMountedEvent" />

  <!-- メモ画面 -->
  <b-modal v-model="modalMemo" size="lg" header-bg-variant="secondary" header-text-variant="light" no-stacking
    no-close-on-backdrop no-close-on-esc centered scrollable>
    <template v-slot:header>
      <div class="text-center w-100">
        {{ $t('message.header_vehicle_dtc_note_modal') }}
      </div>
    </template>

    <memo-page v-if="modalMemo" ref="memo" :projectId="projectId" :measureId="measureId" :functionNameKey="navItemLabel"
      :obdFunctionLabelKey="obdFunctionLabelKey" :destinationAPI="destinationAPI" :modalLoading="isMemoDialogLoading"
      @closeNoteModal="closeNoteModal" @update-loading="isMemoDialogLoading = $event" />

    <template v-slot:footer>
      <button type="button" :disabled="isMemoDialogLoading" v-on:click="memoClear()"
        class="btn clear-button ml-3 btn-outline-primary btn-sm rounded-pill">
        {{ $t("message.common_button_clear") }}
      </button>
      <div class="text-center w-100">
        <b-button size="sm" :disabled="isMemoDialogLoading" variant="outline-primary" @click="modalMemo = false"
          class="ml-2 mr-2">
          {{ $t("message.common_button_cancel") }}
        </b-button>
        <b-button size="sm" :disabled="isMemoDialogLoading" variant="primary" @click="memoSave()" class="ml-2 mr-2">
          {{ $t('message.common_button_save') }}
        </b-button>
      </div>
    </template>
  </b-modal>

  <!-- CSVエクスポート時のプログレスバー -->
  <b-modal v-model="showCsvProgress" id="dm-play-export-csv-progress" size="lg" header-bg-variant="secondary"
    header-text-variant="light" no-stacking no-close-on-backdrop no-close-on-esc centered hide-footer>
    <template v-slot:header>
      <div class="text-center w-100">
        {{ $t('individual.data_monitor_csv_export_progress_title') }}
      </div>
    </template>

    <template v-slot:default>
      <div class="container-fluid mt-2 mb-2">
        <custom-progress :value="exportPercentage" :message="$t('individual.data_monitor_csv_export_progress_message')" />
      </div>
    </template>
  </b-modal>

  <processing-view :processing="processing"></processing-view>
</div>